import { URLS } from "Common/urls";
import RestService from "Services/RestService";

const { createContext, useState, useContext, useEffect } = require("react");

const AUTH_USER = "auth_user"
const AUTH_TOKEN = "auth_token"

// const getUser = () => localStorage.getItem(AUTH_USER)
const saveUser = user => localStorage.setItem(AUTH_USER, user)
const removeUser = () => localStorage.removeItem(AUTH_USER)

const saveToken = token => localStorage.setItem(AUTH_TOKEN, token)
const getToken = () => localStorage.getItem(AUTH_TOKEN)

const SysBrewAuthContext = createContext()

const SysBrewAuthProvider = ({ children }) => {
    const [user, setUser] = useState({})
    const [isLoading, setLoading] = useState(false)
    const [isAuthenticated, setAuthenticated] = useState(false)
    const [token, setToken] = useState(undefined)
    const [error, setError] = useState(false)
    const [errorDescription, setErrorDescription] = useState(undefined)

    useEffect(() => {
        if (getToken()) {
            setLoading(true)
            RestService.post(URLS.AUTHENTICATE_TOKEN)
                .then(({ statusCode, data }) => {
                    if (statusCode === 200) {
                        if (data.id && data.code) {
                            setToken(data['acumen-token'])
                            saveToken(data['acumen-token'])
                            setUser(data)
                            delete data['acumen-token']
                            saveUser(JSON.stringify(data))
                            setAuthenticated(true)
                            setError(false)
                        } else if (data && data.message) {
                            setAuthenticated(false)
                            setError(true)
                        }
                    } else {
                        setAuthenticated(false)
                        setError(true)
                    }
                })
                .catch((error) => {
                    setAuthenticated(false)
                    setError(true)
                })
                .finally(() => {
                    setLoading(false)
                })
        }
    }, [])

    const logout = ({ returnTo = undefined }) => {
        removeUser()
        setToken(undefined)
        setUser({})
        setAuthenticated(false)
    }

    const loginWithRedirect = (userId, password, redirectTo) => {
        setLoading(true)
        RestService.post(URLS.LOGIN, { login_id: userId, password })
            .then(({ statusCode, data }) => {
                if (statusCode === 200) {
                    setToken(data['acumen-token'])
                    saveToken(data['acumen-token'])
                    setUser(data)
                    delete data['acumen-token']
                    saveUser(JSON.stringify(data))
                    setAuthenticated(true)
                    setError(false)
                    setErrorDescription(undefined)
                } else {
                    setAuthenticated(false)
                    setError(true)
                }
            })
            .catch((error) => {
                console.log(error)
                setErrorDescription(error && error.error && error.error.description)
                setAuthenticated(false)
                setError(true)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <SysBrewAuthContext.Provider value={{
            user,
            setUser,
            isLoading,
            setLoading,
            isAuthenticated,
            setAuthenticated,
            logout,
            token,
            loginWithRedirect,
            error,
            errorDescription
        }}>
            {children}
        </SysBrewAuthContext.Provider>
    )
}

const useSysBrewAuth = () => {
    const { user,
        isLoading,
        isAuthenticated,
        logout,
        token,
        error,
        loginWithRedirect,
        errorDescription
    } = useContext(SysBrewAuthContext)


    return {
        user,
        isLoading,
        isAuthenticated,
        token,
        logout,
        error,
        loginWithRedirect,
        errorDescription
    }
}

export { SysBrewAuthProvider, useSysBrewAuth }